module.exports = __webpack_public_path__ + "h5/img/logo3.3c849848.png";